import { Injectable } from '@angular/core';
import { WebSocketEventRoutingService } from './web-socket-event-routing.service';
import { WSEventType } from '../../../models/WSEventType';
import { Observable, Subject } from 'rxjs/Rx';

@Injectable({
  providedIn: 'root'
})
export class PaymentWebSocketHandlerService {

  private _paymentSubject: Subject<any>;
  private readonly _paymentObservable: Observable<any>;

  constructor(private _webSocketEventRoutingService: WebSocketEventRoutingService) {
    let subject = new Subject<any>();
    subject.asObservable().subscribe(payment => {
      this.processPayment(payment.body);
    });
    this._webSocketEventRoutingService.subscribe(WSEventType.CHANGE_VIEW, subject);
    this._webSocketEventRoutingService.subscribe(WSEventType.OFFER_MPAY, subject);
    this._paymentSubject = new Subject<any>();
    this._paymentObservable = this._paymentSubject.asObservable();
  }

  get paymentObservable() {
    return this._paymentObservable;
  }

  private processPayment(payment: any) {
    this._paymentSubject.next(payment);
  }
}
